document.addEventListener('DOMContentLoaded', () => {
  const indicators = document.querySelectorAll('.product__live-stock-indicator');
  
  indicators.forEach(container => {
    const sectionId = container.closest('[data-section]')?.dataset.section || 'default';
    const variantScript = container.querySelector('[data-variant-inventory]');
    const initialStock = parseInt(container.dataset.initialStock) || 100;
    const deliveryDays = parseInt(container.dataset.deliveryDays) || 3;
    
    if (!variantScript) return;
    
    let variantData = {};
    try {
      variantData = JSON.parse(variantScript.textContent);
    } catch (e) {
      return;
    }

    function calculateDeliveryDate() {
      const today = new Date();
      const deliveryDate = new Date(today);
      deliveryDate.setDate(today.getDate() + deliveryDays);
      
      // Format date as "1st August"
      const day = deliveryDate.getDate();
      const month = deliveryDate.toLocaleString('en-US', { month: 'long' });
      
      // Add ordinal suffix
      const getOrdinalSuffix = (n) => {
        const s = ['th', 'st', 'nd', 'rd'];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
      };
      
      return `${getOrdinalSuffix(day)} ${month}`;
    }

    function updateStock(variantId) {
      const variant = variantData[variantId];
      if (!variant) return;

      const stock = variant.inventory_quantity || 0;
      const soldPercentage = Math.min(100, ((initialStock - stock) * 100) / initialStock);

      // Update stock status
      const statusEl = document.getElementById(`stock-status-${sectionId}`);
      if (statusEl) {
        statusEl.classList.remove('in-stock', 'sold-out');
        statusEl.classList.add(stock <= 0 ? 'sold-out' : 'in-stock');
      }

      // Update progress bar
      const progressEl = document.getElementById(`progress-bar-${sectionId}`);
      if (progressEl) {
        progressEl.style.cssText = `
          width: ${stock <= 0 ? 100 : soldPercentage}%;
        `;
      }

      // Update percentage text
      const percentageEl = document.getElementById(`stock-percentage-${sectionId}`);
      if (percentageEl) {
        percentageEl.textContent = `${Math.round(soldPercentage)}% Sold`;

      }

      // Update stock count
      const countEl = document.getElementById(`stock-count-${sectionId}`);
      if (countEl) {
        countEl.textContent = stock <= 0 ? 'Out of stock' : `${stock} Left`;
      }

      // Update delivery date
      const deliveryEl = document.getElementById(`delivery-date-${sectionId}`);
      if (deliveryEl && stock > 0) {
        deliveryEl.textContent = calculateDeliveryDate();
      } else if (deliveryEl) {
        deliveryEl.textContent = 'Not available';
      }
    }

    // Listen for variant changes
    document.addEventListener('change', (e) => {
      if (e.target.name === 'id' || e.target.type === 'radio' || e.target.tagName === 'SELECT') {
        setTimeout(() => {
          const hiddenInput = document.querySelector('input[name="id"]');
          if (hiddenInput?.value) updateStock(hiddenInput.value);
        }, 50);
      }
    });

    // Initialize with current variant
    const currentVariant = document.querySelector('input[name="id"]');
    if (currentVariant?.value) {
      updateStock(currentVariant.value);
    }
  });
});